import React from 'react'
import { useDispatch } from 'react-redux'
import { moveNotesTo } from 'data/notes/actions'

export default function useMoveNotesTo(noteIds) {
  const dispatch = useDispatch()
  return React.useCallback(
    ({ channelId, parentNoteId }) => {
      dispatch(
        moveNotesTo({
          channelId,
          parentNoteId,
          noteIds,
          analyticsSource: 'modal',
        })
      )
    },
    [dispatch, noteIds]
  )
}
